module.exports = __webpack_public_path__ + "img/lala_scroll03.b043df28.webp";